<template>
  <div style="position: absolute; top: 10px; left: 0px;z-index: 10;">
    <v-dialog
      persistent
      class="elevation-2"
      width="280px"
      v-model="bottomSheetActive"
    >
      <v-card style="border-radius: 5px;">
        <v-card-text class="ma-0 pa-1">
          <v-layout row justify-center align-center>
            <v-text-field
              box
              ref="graphicTitleTextField"
              @keyup.enter="setGraphicTitle"
              color="grey"
              single-line
              v-if="bottomSheetActive"
              autofocus
              full-width
              hide-details
              label
              v-model="graphicTitle"
              placeholder="Gi elementet et navn"
            ></v-text-field>
          </v-layout>
          <v-layout row justify-end align-end>
            <v-btn
              color="blue"
              block
              dark
              height="50px"
              depressed
              @click="setGraphicTitle"
              >Lagre</v-btn
            >
            <v-btn @click="bottomSheetActive = false" block depressed
              >Ikke nå</v-btn
            >
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <map-drawing-add-or-edit-drawing-layer-dialog
      v-if="selectLayerDialog"
      @start-drawing="loadDrawing"
    />
    <div></div>
    <v-toolbar
      :floating="$vuetify.breakpoint.mdAndUp"
      class="drawing-toolbar elevation-2"
      :class="
        $vuetify.breakpoint.mdAndUp
          ? 'drawing-toolbar-mdandup'
          : 'drawing-toolbar-smanddown'
      "
      v-show="selectLayerDialog == false && graphicsLayer !== null"
    >
      <div
        @click="setTool"
        style="background: transparent !important"
        id="sketchDiv"
      ></div>

      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          v-show="tool == 'point'"
          @click="selectedPointStyleDialogActive = true"
          class="choose-symbol-btn"
        >
          <div
            style="margin-top: 2px;"
            v-html="selectedRenderedPointStyle"
          ></div>
        </v-btn>
        <span>Velg symbol</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          v-show="tool === 'polyline'"
          @click="selectedPolylineStyleDialogActive = true"
          class="choose-symbol-btn"
        >
          <div
            style="margin-top: 2px;"
            v-html="selectedRenderedLineStyle"
          ></div>
        </v-btn>
        <span>Velg symbol</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          slot="activator"
          depressed
          v-show="
            tool === 'polygon' || tool === 'circle' || tool === 'rectangle'
          "
          @click="selectedPolygonStyleDialogActive = true"
          class="choose-symbol-btn"
        >
          <div
            style="margin-top: 2px;"
            v-html="selectedRenderedPolygonStyle"
          ></div>
        </v-btn>
        <span>Velg symbol</span>
      </v-tooltip>

      <map-drawing-symbol-selection-dialog
        :index="selectedRenderedPointStyleIndex"
        v-show="tool === 'point'"
        :active="selectedPointStyleDialogActive"
        tool="point"
        :symbols="renderedPointStyles"
        @symbol-selected="setSelectedStyle"
        @close-dialog="closeSymbolSelectionDialogs"
      />
      <map-drawing-symbol-selection-dialog
        :index="selectedRenderedLineStyleIndex"
        :active="selectedPolylineStyleDialogActive"
        v-show="tool === 'polyline'"
        tool="polyline"
        :symbols="renderedLineStyles"
        @symbol-selected="setSelectedStyle"
        @close-dialog="closeSymbolSelectionDialogs"
      />
      <map-drawing-symbol-selection-dialog
        :index="selectedRenderedPolygonStyleIndex"
        :active="selectedPolygonStyleDialogActive"
        v-show="updateGraphics !== 0"
        tool="polygon"
        :symbols="renderedPolygonStyles"
        @symbol-selected="setSelectedStyle"
        @close-dialog="closeSymbolSelectionDialogs"
      />

      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn slot="activator" small @click="close" flat color="blue"
          >Avslutt</v-btn
        >
        <span>Avslutt tegneverktøy</span>
      </v-tooltip>

      <map-drawing-change-layer-name-dialog
        v-if="selectedMapProfile"
        :active="changeLayerNameDialogActive"
        :current-name="selectedMapProfile.appTitle"
        :current-description="selectedMapProfile.Temaforklaring"
        @close-dialog="deactivateChangeLayerNameDialog"
        :layer="selectedMapProfile"
      ></map-drawing-change-layer-name-dialog>
    </v-toolbar>
    <v-slide-y-transition>
      <v-toolbar
        absolute
        v-show="updateGraphics !== 0"
        width="300px"
        dense
        :class="
          $vuetify.breakpoint.mdAndUp
            ? 'edit-toolbar-mdandup'
            : 'edit-toolbar-smanddown'
        "
        :style="{
          width: $vuetify.breakpoint.mdAndUp ? '483px' : '100vw',
        }"
      >
        <v-tooltip bottom>
          <v-btn
            class="ml-2"
            slot="activator"
            small
            flat
            color="blue"
            @click="openStyleDialogBasedOnGraphicBeingEdited"
            >Endre symbol</v-btn
          >

          <span>Endre symbolet til elementet</span>
        </v-tooltip>

        <v-tooltip bottom v-show="updateGraphics !== 0">
          <v-btn
            class="ml-2"
            slot="activator"
            small
            flat
            :disabled="updateGraphics > 1"
            color="blue"
            @click="activateBottomSheet(lastAddedGraphic)"
            >Endre navn</v-btn
          >

          <span>Endre navnet til elementet</span>
        </v-tooltip>

        <v-tooltip bottom v-show="updateGraphics !== 0">
          <v-btn
            class="ml-2"
            slot="activator"
            small
            flat
            color="blue"
            @click="deleteSelectedGraphics"
            >Fjern element</v-btn
          >

          <span>Fjern elementet fra kartlaget</span>
        </v-tooltip>
      </v-toolbar>
    </v-slide-y-transition>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import MappingMixin from "@/mixins/mappingMixin";
import { mapState, mapActions, mapGetters } from "vuex";
import MapDrawingSymbolSelectionDialog from "@/pages/MapPage/Tools/Drawing/MapDrawingSymbolSelectionDialog";
import MapDrawingAddOrEditDrawingLayerDialog from "@/pages/MapPage/Tools/Drawing/MapDrawingAddOrEditDrawingLayerDialog";
import MapDrawingChangeLayerNameDialog from "@/pages/MapPage/Tools/Drawing/MapDrawingChangeLayerNameDialog";
export default {
  name: "MapDrawing",
  components: {
    MapDrawingSymbolSelectionDialog,
    MapDrawingAddOrEditDrawingLayerDialog,
    MapDrawingChangeLayerNameDialog,
  },
  mixins: [MappingMixin],
  data: function() {
    return {
      changeLayerNameDialogActive: false,
      bottomSheetActive: false,
      polygonStyles: [
        "solid",
        "backward-diagonal",
        "cross",
        "vertical",
        "forward-diagonal",
        "horizontal",
      ],
      lineStyles: ["solid", "dash", "dash-dot", "dot"],
      drawingTools: [
        {
          name: "point",
          icon: "esri-icon-map-pin",
          tooltip: "Punkt",
        },
        {
          name: "polyline",
          icon: "esri-icon-polyline",
          tooltip: "Linje",
        },
        {
          name: "polygon",
          icon: "esri-icon-polygon",
          tooltip: "Flate",
        },
        {
          name: "transform",
          icon: "edit",
          tooltip: "Rediger",
        },
      ],
      selectedPointStyleDialogActive: false,
      selectedPolylineStyleDialogActive: false,
      selectedPolygonStyleDialogActive: false,
      sketchViewModel: null,
      graphics: [],
      graphicsLayer: null,
      tool: "",
      selectLayerDialog: false,
      selectedRenderedPointStyleIndex: null,
      selectedRenderedLineStyleIndex: null,
      selectedRenderedPolygonStyleIndex: null,
      updateGraphics: 0,
      selected: [],
      lineSymbols: [],
      polygonSymbols: [],
      pointSymbols: [],
      pointMarkerStyles: ["circle", "diamond", "square"],
      pointMarkerSymbols: [],
      showBottomSheetTextField: false,
      iconSize: 14,
      lineWidth: 2,
      iconSizes: [4, 6, 12, 16],
      lineWidths: [1, 2, 3],
      opacities: [0.2, 0.4, 0.6, 1.0],
      graphicTitle: "",
      renderedPointStyles: [],
      renderedLineStyles: [],
      renderedPolygonStyles: [],
      counter: 0,
      colors: [
        { title: "Blå", rgb: [32, 150, 243] },
        { title: "Grønn", rgb: [75, 175, 80] },
        { title: "Rød", rgb: [244, 67, 54] },
        { title: "Gul", rgb: [255, 235, 58] },
        { title: "Oransje", rgb: [254, 152, 2] },
        { title: "Rosa", rgb: [233, 30, 99] },
        { title: "Svart", rgb: [0, 0, 0] },
      ],
      selectedRenderedGraphic: null,
      selectedRenderedGraphicStyle: null,
      selectedRenderedGraphicNewSymbol: null,
      lastAddedGraphic: null,
    };
  },

  computed: {
    ...mapState(["mapProfiles", "pointStyles", "is3d", "userSettings"]),
    ...mapGetters(["getDrawPointSymbols"]),
    selectedMapProfile: {
      set(selectedMapProfile) {
        this.setSelectedMapProfile(selectedMapProfile);
      },
      get() {
        return this.$store.state.selectedMapProfile;
      },
    },
    selectedRenderedPointStyle() {
      return this.selectedRenderedPointStyleIndex !== null
        ? this.renderedPointStyles[this.selectedRenderedPointStyleIndex]
        : this.renderedPointStyles[0];
    },
    selectedRenderedLineStyle() {
      return this.selectedRenderedLineStyleIndex
        ? this.renderedLineStyles[this.selectedRenderedLineStyleIndex]
        : this.renderedLineStyles[0];
    },
    selectedRenderedPolygonStyle() {
      return this.selectedRenderedPolygonStyleIndex
        ? this.renderedPolygonStyles[this.selectedRenderedPolygonStyleIndex]
        : this.renderedPolygonStyles[0];
    },
  },
  watch: {
    bottomSheetActive(newVal) {
      if (!newVal) {
        this.graphicTitle = "";
      }
    },
    is3d(newVal, oldVal) {
      if (newVal !== oldVal)
        this.sketchViewModel.view = newVal
          ? this.$theSceneViewObject
          : this.$theMapViewObject;
    },
  },
  methods: {
    ...mapActions([
      "setShowPopupsOnClick",
      "setSelectedMapProfile",
      "addGraphicsLayer",
      "deactivateTool",
    ]),
    setTool: function(evt) {
      evt.target.className;
      if (evt.target && evt.target.className.includes("polygon")) {
        this.tool = "polygon";
      } else if (evt.target && evt.target.className.includes("radio")) {
        this.tool = "polygon";
      } else if (evt.target && evt.target.className.includes("checkbox")) {
        this.tool = "polygon";
      } else if (evt.target && evt.target.className.includes("polyline")) {
        this.tool = "polyline";
      } else if (evt.target && evt.target.className.includes("map-pin")) {
        this.tool = "point";
      } else {
        this.tool = null;
      }
    },
    deactivateChangeLayerNameDialog() {
      this.changeLayerNameDialogActive = false;
    },
    activateChangeLayerNameDialog() {
      this.changeLayerNameDialogActive = true;
    },
    setGraphicTitle: function() {
      this.$set(
        this.lastAddedGraphic.attributes,
        "name",
        this.graphicTitle ? this.graphicTitle : ""
      );
      this.$set(this.lastAddedGraphic, "popupTemplate", {
        title: this.graphicTitle ? "{name}" : "",
      });
      let text = this.graphicTitle;
      this.updateTextSymbol(this.lastAddedGraphic, text);

      this.graphicTitle = "";
      this.bottomSheetActive = false;

      this.$eventHub.$emit("graphicslayer-updated", this.graphicsLayer.id);
    },
    updateTextSymbol: function(graphic, text) {
      loadModules(["esri/symbols/TextSymbol"]).then(([TextSymbol]) => {
        if (graphic.symbol.type === "text") {
          let textSymbolJSON = graphic.symbol.toJSON();
          textSymbolJSON.text = text ? text : "Uten navn";
          graphic.symbol = TextSymbol.fromJSON(textSymbolJSON);
        }
      });
    },
    openStyleDialogBasedOnGraphicBeingEdited: function() {
      if (this.selectedRenderedGraphic !== null) {
        switch (this.selectedRenderedGraphic.geometry.type) {
          case "point":
            this.selectedPointStyleDialogActive = true;
            break;
          case "polyline":
            this.selectedPolylineStyleDialogActive = true;
            break;
          case "polygon":
            this.selectedPolygonStyleDialogActive = true;
            break;
        }
      }
    },
    closeSymbolSelectionDialogs: function() {
      this.selectedPointStyleDialogActive = false;
      this.selectedPolylineStyleDialogActive = false;
      this.selectedPolygonStyleDialogActive = false;
    },
    deleteSelectedGraphics: function() {
      this.graphicsLayer.removeMany(
        this.sketchViewModel.viewModel.updateGraphics.items
      );
      this.graphicsLayer.removeMany(
        this.sketchViewModel.viewModel.updateGraphics.moved
      );
      this.sketchViewModel.cancel();
    },
    setSelectedStyle: function(tool, index) {
      this.closeSymbolSelectionDialogs();
      switch (tool) {
        case "point":
          if (this.selectedRenderedGraphic == null) {
            this.sketchViewModel.viewModel.pointSymbol = this.pointSymbols[
              index
            ];
            this.selectedRenderedPointStyleIndex = index;
          } else {
            this.selectedRenderedGraphicNewSymbol = this.pointSymbols[index];
          }

          break;
        case "polyline":
          if (this.selectedRenderedGraphic == null) {
            this.sketchViewModel.viewModel.polylineSymbol = this.lineSymbols[
              index
            ];
            this.selectedRenderedLineStyleIndex = index;
          } else {
            this.selectedRenderedGraphicNewSymbol = this.lineSymbols[index];
          }
          break;
        default:
          if (this.selectedRenderedGraphic == null) {
            this.sketchViewModel.viewModel.polygonSymbol = this.polygonSymbols[
              index
            ];
            this.selectedRenderedPolygonStyleIndex = index;
          } else {
            this.selectedRenderedGraphicNewSymbol = this.polygonSymbols[index];
          }
          break;
      }
      this.updateTool();
    },
    close: function() {
      this.setShowPopupsOnClick(true);

      this.closeAndResetBottomSheet();
      this.selectLayerDialog = false;

      loadModules(["esri/widgets/Popup"]).then(([Popup]) => {
        this.$theMapViewObject.popup = new Popup();
        this.$theMapViewObject.popup.dockOptions = {
          breakpoint: {
            width: 600,
            height: 544,
          },
          position: "bottom-center",
        };
        if (this.$theSceneViewObject) {
          this.$theSceneViewObject.popup = new Popup();
          this.$theSceneViewObject.popup.dockOptions = {
            breakpoint: {
              width: 600,
              height: 544,
            },
            position: "bottom-center",
          };
          this.enablePopupGeometryHighlight(this.$theSceneViewObject);
        }

        this.enablePopupGeometryHighlight(this.$theMapViewObject);

        if (this.sketchViewModel) {
          this.sketchViewModel.updateOnGraphicClick = false;
          this.sketchViewModel.cancel();
          this.sketchViewModel.destroy();
        }

        this.tool = "";
        this.setSelectedMapProfile(null);
        this.deactivateTool("drawing");
      });
    },
    closeAndResetBottomSheet() {
      this.graphicTitle = "";
      this.lastAddedGraphic = null;
      this.bottomSheetActive = false;
    },
    updateTool: function() {
      if (this.sketchViewModel) {
        this.sketchViewModel.cancel();
      } else {
        return;
      }

      this.create(this.tool);
    },
    activateTool: function(tool) {
      this.closeAndResetBottomSheet();
      this.sketchViewModel.cancel();
      if (tool !== "reshape" && tool !== "transform") {
        this.create(tool);
      } else {
        this.sketchViewModel.defaultUpdateOptions = {
          tool: tool,
        };
        this.sketchViewModel.updateOnGraphicClick = true;
      }
    },
    create: function(tool) {
      this.sketchViewModel.create(tool, {
        mode: "click",
      });
    },
    activateBottomSheet: function(graphic) {
      this.showBottomSheetTextField = false;
      setTimeout(() => {
        this.bottomSheetActive = false;
      }, 500);
      this.lastAddedGraphic = graphic;
      setTimeout(() => {
        this.bottomSheetActive = true;
      }, 500);
    },
    getSymbolHtml: function(symbol) {
      return new Promise((resolve, reject) => {
        if (symbol.type == "web-style") {
          resolve(
            '<img src="/svg/' + symbol.name.replace(/\s/g, "") + '.svg" />'
          );
          return;
        }

        return loadModules(["esri/symbols/support/symbolUtils"])
          .then(function([symbolUtils]) {
            if (typeof symbol === "object") {
              symbolUtils
                .renderPreviewHTML(symbol)
                .then((result) => {
                  // Linje under setter en stroke på generert svg preview av symbolet (dette gjøres ikke av ArcGIS selv)
                  result.firstChild.children[1].firstChild.attributes.stroke.value =
                    "black";
                  resolve(result.outerHTML);
                })
                .catch((error) => {
                  console.error(error);
                });
            } else {
              resolve(symbol);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadDrawing: function(graphicsLayer) {
      this.selectedMapProfile.open = true;
      if (this.sketchViewModel) {
        this.sketchViewModel.destroy();
      }
      this.setPopupEnabled(false);
      this.$theMapViewObject.popup = null;
      if (this.$theSceneViewObject) {
        this.$theSceneViewObject.popup = null;
      }

      this.setShowPopupsOnClick(false);

      this.selectLayerDialog = false;

      loadModules([
        "esri/widgets/Sketch",
        "esri/symbols/support/symbolUtils",
      ]).then(
        function([Sketch, symbolUtils]) {
          this.graphicsLayer = graphicsLayer;

          this.sketchViewModel = new Sketch({
            layer: this.graphicsLayer,
            creationMode: this.userSettings.drawingCreationMode,
            defaultCreateOptions: {
              hasZ: this.userSettings.useZvaluesWhenDrawingIn3D,
              mode: this.userSettings.drawingInputMode,
            },
            view: this.is3d ? this.$theSceneViewObject : this.$theMapViewObject,
            container: "sketchDiv",
          });

          this.generateSymbols();

          this.graphicsLayer.watch(
            "graphics",
            function(graphics) {
              this.graphics = graphics.items;
            }.bind(this)
          );

          this.sketchViewModel.viewModel.updateGraphics.on(
            "change",
            function(graphics) {
              this.updateGraphics = graphics.added.length;
            }.bind(this)
          );

          this.sketchViewModel.on(
            "update",
            function(event) {
              if (event.state === "start") {
                let graphic = event.graphics[0];
                this.lastAddedGraphic = graphic;
                this.graphicTitle = graphic.attributes.name;

                this.selectedRenderedGraphic = graphic;
                if (graphic.htmlSymbol) {
                  this.selectedRenderedGraphicStyle =
                    graphic.htmlSymbol.outerHTML;
                } else {
                  symbolUtils
                    .renderPreviewHTML(graphic.symbol)
                    .then((result) => {
                      this.selectedRenderedGraphicStyle = result;
                    });
                }
              }
              if (event.state === "complete" || event.aborted) {
                this.selectedRenderedGraphicStyle = null;
                this.selectedRenderedGraphic = null;

                event.graphics.forEach((graphic) => {
                  if (this.selectedRenderedGraphicNewSymbol) {
                    if (
                      graphic.geometry.type === "point" &&
                      this.selectedRenderedGraphicNewSymbol.type ===
                        "simple-fill"
                    ) {
                      return;
                    } else {
                      graphic.symbol = this.selectedRenderedGraphicNewSymbol;

                      symbolUtils
                        .renderPreviewHTML(graphic.symbol)
                        .then((result) => {
                          graphic.htmlSymbol = result;
                        });
                    }
                  }

                  this.updateTextSymbol(graphic, graphic.attributes.name);

                  this.$set(graphic, "popupTemplate", {
                    title: this.graphicTitle ? "{name}" : "",
                  });
                  this.graphicTitle = "";
                });
                this.selectedRenderedGraphicNewSymbol = null;
              }
            }.bind(this)
          );

          this.sketchViewModel.on(
            "create",
            function(event) {
              if (event.state === "complete") {
                this.activateBottomSheet(event.graphic);

                this.$set(event.graphic, "attributes", {
                  id: this.counter,
                  name: "",
                });

                event.graphic.name = "";
                event.graphic.id = this.counter;
                this.counter++;
                symbolUtils
                  .renderPreviewHTML(event.graphic.symbol)
                  .then((result) => {
                    event.graphic.htmlSymbol = result;
                  });

                this.graphics = this.graphicsLayer.graphics.items;

                this.tool = null;
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },

    generateLineSymbols: function() {
      this.lineSymbols = [];
      this.colors.forEach((color) => {
        this.lineStyles.forEach((lineStyle) => {
          this.lineWidths.forEach((lineWidth) => {
            this.lineSymbols.push({
              type: "simple-line",
              style: lineStyle,
              width: lineWidth,
              color: color.rgb,
            });
          });
        });
      });
      this.sketchViewModel.viewModel.polylineSymbol = this.lineSymbols[2];
    },
    generatePolygonSymbols: function() {
      this.polygonSymbols = [];
      this.colors.forEach((color) => {
        this.opacities.forEach((opacity) => {
          let colorWithOpacity = color.rgb.concat([opacity]);

          this.polygonSymbols.push({
            type: "simple-fill",
            style: "solid",
            outline: { color: [0, 0, 0, 0.95] },
            color: colorWithOpacity,
          });
        });
      });
      // Transparent polygon med sort omriss
      this.polygonSymbols.push({
        type: "simple-fill",
        style: "none",
        outline: { color: [0, 0, 0, 0.95], width: 2 },
        color: [0, 0, 0, 0.0],
      });
      this.sketchViewModel.viewModel.polygonSymbol = this.polygonSymbols[0];
    },
    generatePointSymbols: function() {
      let pointMarkerSymbols = [];
      this.iconSizes.forEach((size) => {
        this.colors.forEach((color) => {
          this.pointMarkerStyles.forEach((markerStyle) => {
            pointMarkerSymbols.push({
              type: "simple-marker",
              size: size,

              style: markerStyle,
              color: color.rgb,
            });
          });
        });
      });
      this.pointSymbols = this.pointStyles.concat(pointMarkerSymbols);
      this.sketchViewModel.viewModel.pointSymbol = this.pointSymbols[0];
    },
    generateSymbols: function() {
      this.generateLineSymbols();
      this.generatePolygonSymbols();
      this.generatePointSymbols();

      this.pointSymbols.forEach((symbol) => {
        this.getSymbolHtml(symbol).then((result) => {
          this.renderedPointStyles.push(result);
        });
      });

      this.lineSymbols.forEach((symbol) => {
        this.getSymbolHtml(symbol).then((result) => {
          this.renderedLineStyles.push(result);
        });
      });

      this.polygonSymbols.forEach((symbol) => {
        this.getSymbolHtml(symbol).then((result) => {
          this.renderedPolygonStyles.push(result);
        });
      });
    },
    addNewGraphicsLayer: function() {
      loadModules(["esri/layers/GraphicsLayer"]).then(([GraphicsLayer]) => {
        let id = new Date().getTime().toString();
        let graphicsLayer = new GraphicsLayer({
          id: id,
        });
        this.$theMapObject.add(graphicsLayer);
        this.addGraphicsLayer(id);
        let newMapProfile = {
          id: id,
          showInfoMenu: false,
          appTitle: "Tegnelag",
          Temaforklaring: "",
          open: true,
        };
        this.addMapProfile(newMapProfile);

        this.setSelectedMapProfile(newMapProfile);
        this.loadDrawing(graphicsLayer);
      });
    },
  },
  mounted() {
    if (this.selectedMapProfile == null) {
      let allAddedGraphicLayers = this.mapProfiles.filter((profile) => {
        return profile.type === "graphicsLayer";
      });
      if (allAddedGraphicLayers.length > 0) {
        this.selectLayerDialog = true;
      } else {
        this.addNewGraphicsLayer();
      }
    } else {
      let graphicsLayer = this.$theMapObject.findLayerById(
        this.selectedMapProfile.id
      );

      this.loadDrawing(graphicsLayer);
    }
  },
};
</script>

<style>
.v-btn-toggle .v-btn {
  opacity: 1;
}

.draw-button {
  height: 60px;
}

.choose-symbol-btn {
  margin: 10px !important;
  margin-top: 14px !important;
  max-height: 37px;
  min-width: 40px;
}

.editing-action-btn {
  position: absolute;
  left: 10px;
  min-width: 30px;
}

.esri-sketch__panel.esri-sketch__info-panel {
  display: none !important;
}

.edit-dialog.v-dialog {
  position: absolute;
  top: 8px;
  right: 0px;
  margin: 10px;
}

.drawing-toolbar-mdandup {
  z-index: 1000;
  margin-top: 10px;
  margin-left: 10px;
  border-radius: 5px;
  margin-bottom: 0px;
}

.drawing-toolbar-smanddown {
  z-index: 1000;
  position: absolute;
  overflow-x: scroll;
  overflow-y: hidden;
  top: -10px;
  border-radius: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
  width: 100vw;
}

.edit-toolbar-mdandup {
  z-index: 999;
  margin: 0px;
  left: 10px;
  border-radius: 5px;
  top: 60px;
  width: 470px;
}

.edit-toolbar-smanddown {
  z-index: 999;
  margin: 0px;
  left: 0px;
  border-radius: 5px;
  top: 50px;
}
</style>
